import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";

import Hidden from "@material-ui/core/Hidden";

import CurrencyTabs from "../../components/CurrencyTabs";
import NotFoundPage from "../NotFoundPage";
import { useDispatch } from "react-redux";
import { SET_MOBILE_TAB } from "../../redux/types";

export default function MobileCurrency() {
  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: SET_MOBILE_TAB, payload: 0 });
  }, []);
  return (
    <div className={classes.container}>
      <Hidden mdUp>
        <CurrencyTabs position={true} />
      </Hidden>

      <Hidden smDown>
        <NotFoundPage />
      </Hidden>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
      // minWidth: "450px",
      maxWidth: "450px",
      overflow: "scroll",
      maxHeight: "110vh",
    },
    backgroundColor: theme.palette.type === "dark" ? "#151827" : "white",
  },
}));
